import { get, isString } from "lodash";
import setIfNotSet from "../../../setIfNotSet";
import env from "../../../env";
import { DEVELOPMENT, E2E, STAGING } from "../../../constants/environment";
// DO NOT ADD PRODUCTION
var ENVIRONMENT_WHITELIST = [DEVELOPMENT, STAGING, E2E];
/**
 * @description: Adds a query param to a graph request.
 * This has no functional use, it just makes it easier to debug in the network tab.
 */
export default function setOperationNameToParams(config) {
    if (config === void 0) { config = {}; }
    if (ENVIRONMENT_WHITELIST.includes(env.ENVIRONMENT_NAME)) {
        var data = config.data;
        if (data && isString(data)) {
            var operationName = get(JSON.parse(data), "operationName");
            setIfNotSet(config, "params.opName", operationName);
        }
    }
}
